export default (pnrInfo) => {
  const legCollection = pnrInfo?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  let tripType = 'MC';
  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const mcOutBoundDepartureDate = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      const departureDate = segment?.departureDateTime?.format('YYYYMMDD') || 'NA';
      return departureDate;
    }).join('/');
    return segments;
  }).join('-');
 
  const mcOutBoundArrivalDate = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      const arrivalDate = segment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
      return arrivalDate;
    }).join('/');
    return segments;
  }).join('-');
  const outboundDeparture =  tripType === 'MC' ? mcOutBoundDepartureDate : outboundDepartureDate || 'NA';
  const outboundArrival =  tripType === 'MC' ? mcOutBoundArrivalDate : outboundArrivalDate || 'NA';

  const zone = pnrInfo?.globalMarketFlight === 'DOMESTIC' ? 'DOM' : 'INT';
  const marketSegments = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';

  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }
  const region = getRegionValue(legCollection?.[0]?.legRegion, legCollection?.[0]?.marketFlight, legCollection?.[0]?.regionKey);
  function getRegionValue(legRegion, marketType, regionKey) {
    let region = 'DOM';
    const regionCodeMap = {
      'CAN': 'CAN',
      'USA': 'USA',
    };
    const regionMap = {
      'ASI': 'ASI',
      'ASIA': 'ASI',
      'CANADA': 'CAN',
      'CENTROAMERICA': 'CAM',
      'CENTROAMERICA_CARIBE': 'CAR',
      'DOMESTIC': 'DOM',
      'EUROPA': 'EUR',
      'Frontera': 'FRO',
      'Local': 'LOC',
      'Playa': 'PLA',
      'SUDAMERICA_ASIA': 'SUD',
      'CAN': 'CAN',
      'CAM': 'CAM',
      'CAR': 'CAR',
      'DOM': 'DOM',
      'EUR': 'EUR',
      'FRO': 'FRO',
      'LOC': 'LOC',
      'PLA': 'PLA',
      'SUD': 'SUD',
      'USA': 'USA',
    };

    region = regionMap[legRegion];
    if (!region) {
      if (marketType === 'TRANSBORDER') {
        region = regionCodeMap[regionKey] || 'DOM';
      }
    }
    return region || 'DOM';
  }

  let destination = 'NA';
  let origin = 'NA';

  if (pnrInfo?.flightItineraryType === 'ROUNDTRIP' || pnrInfo?.flightItineraryType === 'ONEWAY') {
    origin = legCollection?.[0]?.segmentsCollection?.[0]?.departureAirport || 'NA';
    destination = legCollection?.[0]?.segmentsCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
  } else {
    origin = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentOrigin = segmentCollection?.[0]?.departureAirport || 'NA';
      return segmentOrigin;
    }).join('-');
    destination = legCollection?.map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentDestination = segmentCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
      return segmentDestination;
    }).join('-');
  }

  return {
    'event': 'myb_step_pax',
    'funnel_name': 'MYB',
    'sub_funnel_name': 'Pax_form',
    'outbound_departure_date': outboundDeparture,
    'inbound_departure_date': inboundDepartureDate,
    'outbound_arrival_date': outboundArrival,
    'inbound_arrival_date': inboundArrivalDate,
    'origin': origin,
    'destination': destination,
    'zone': zone,
    'trip_type': tripType,
    'market_od': marketOd,
    'market_ndod': marketNdod,
    'market_segment': marketSegments,
    'region': region,
    'pnr': pnrInfo.pnrCode,
  };
};